
import FeatherIcon from 'feather-icons-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// types
import { Feature } from './types';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import SalesDashBoard from 'assets/images/hero/New folder/SalesDashBoard.png';
import QuoteAndSalesChart from 'assets/images/hero/New folder/QuoteAndSalesChart.png';
import LeadsOpportunitiAccounts from 'assets/images/hero/New folder/LeadsOpportunitiAccounts.png';
import leadsDetailsView from 'assets/images/hero/New folder/leadsDetailsView.png';

import SupportTicketHistory from 'assets/images/hero/New folder/SupportTicketHistory.png';
import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
import AccountsDetailsView from 'assets/images/hero/New folder/AccountsDetailsView.png';
import opportunityDetails from 'assets/images/hero/New folder/opportunityDetails.png';
import "./Benefits.css";
import { useState } from 'react';


type FeaturesProps = {
    features: Feature[];
};

const Features = ({ features }: FeaturesProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const slides = [SalesDashBoard, QuoteAndSalesChart, LeadsOpportunitiAccounts, leadsDetailsView, opportunityDetails, campaginDetailsView, AccountsDetailsView];
    const [activeText, setActiveText] = useState(0);

    const slidesData = [
        {
            image: SalesDashBoard,
            text: [
                "Monitor how sales orders are distributed across different execution stages. Get clear visibility into delivery and processing performance.",
                "Understand your overall sales performance with key business metrics. Track revenue trends and order efficiency in one unified dashboard."
            ]
        },
        {
            image: QuoteAndSalesChart,
            text: [
                "Monitor the overall quote performance and track how efficiently they convert into orders. This chart highlights your conversion effectiveness and sales closing strength.",
                "Analyze lead progression across contacted, nurturing, qualified, and active stages. Gain insights into overall sales performance and deal outcomes."
            ]
        },
        {
            image: LeadsOpportunitiAccounts,
            text: [
                "Stay informed about lead movement and engagement status in real time.",
                "Visualize deal progress from active discussions to closed outcomes.",
                "Understand account distribution by type to identify key business segments."
            ]
        },
        {
            image: leadsDetailsView,
            text: [
                "Access complete lead information including contact, company, and activity details.",
                "Track status updates and interactions in one centralized view."
            ]
        },
        // {
        //     image: SupportTicketHistory,
        //     text: [
        //         "Monitor ticket activity with a clear overview of new, open, resolved, and closed cases.",
        //         "Track support performance and resolution trends over time."
        //     ]
        // },
        {
            image: campaginDetailsView,
            text: [
                "This screen provides a detailed view of the selected campaign, including campaign information, schedule, and current status.",
                "It also displays distribution details and campaign form responses for each assigned user in a structured format."
            ]
        }
    ];

    const SlideCard = ({ index }: { index: number }) => (
        <Row className="align-items-center g-4 mb-4">
            <Col md={12}>
                <div className="slide-card p-4 rounded shadow-sm h-100">
                    {/* <div className="d-flex align-items-center mb-3">
                        <div className="me-3 slide-badge d-flex align-items-center justify-content-center">
                            <span>{index + 1}</span>
                        </div>
                        <h5 className="mb-0 fw-semibold">Quick overview</h5>
                    </div> */}

                    {slidesData[index]?.text.map((paragraph, i) => (
                        <p key={i} className="slide-card-paragraph mb-2">
                            {/* {paragraph} */}
                            <span className="bullet-dot">•</span> {paragraph}
                        </p>
                    ))}

                </div>
            </Col>

            {/* <Col md={6} className="text-center">
                <div className="slide-preview p-3 bg-white rounded shadow-sm d-inline-block">
                    <img src={slidesData[index]?.image} alt={`preview-${index}`} className="preview-img" />
                </div>
            </Col> */}
        </Row>
    );



    return (
        <>
            <section className="py-5 mt-5   position-relative">
                <Container>
                    <Row className="mb-5">
                        <Col className="text-center">
                            <Badge bg="primary" pill className="mb-3 px-3 py-2">
                                Features
                            </Badge>

                            <p className="text-muted mt-3">
                                Powerful modules that help your business grow, manage customers, and close more deals.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {features.map((benefit, index) => (
                            <Col lg={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="d-flex p-4 bg-white rounded shadow-sm h-100 align-items-start">
                                    <div className="me-4">
                                        <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle" style={{ width: 48, height: 48 }}>
                                            <FeatherIcon icon={benefit.icon} size={20} />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="fw-semibold">{benefit.title}</h5>
                                        <p className="text-muted mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>


            <section className="position-relative py-5">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

                    <SlideCard index={activeIndex} />


                    {/* <div className="dashboard-images text-center position-relative">
                        <img
                            src={Capture}
                            alt="Sales Funnel"
                            className="dashboard-img small-img left-img shadow rounded"
                        />
                        <img
                            src={Capture1}
                            alt="Sales Dashboard"
                            className="dashboard-img main-img shadow-lg rounded"
                        />
                        <img
                            src={Capture2}
                            alt="Q1 Goals"
                            className="dashboard-img small-img right-img shadow rounded"
                        />
                    </div> */}

                    <div className="swiper-wrapper-custom">

                        <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            loop={true}
                            speed={1200}
                            pagination={{
                                clickable: true
                            }}
                            spaceBetween={0}
                            navigation={{
                                prevEl: ".swiper-button-prev-custom",
                                nextEl: ".swiper-button-next-custom",
                            }}
                            onBeforeInit={(swiper) => {
                                // @ts-ignore
                                swiper.params.navigation.prevEl = ".swiper-button-prev-custom";
                                // @ts-ignore
                                swiper.params.navigation.nextEl = ".swiper-button-next-custom";
                                // @ts-ignore
                            }}
                            onSlideChange={(swiper) => {
                                setActiveIndex(swiper.realIndex);
                            }}
                        >
                            {/* {slides.map((img, idx) => (
                                <SwiperSlide key={idx}>
                                    <img src={img} alt={`slide-${idx}`} className="simple-img" />
                                </SwiperSlide>
                            ))} */}
                            {slidesData.map((slide, idx) => (
                                <SwiperSlide key={idx}>
                                    <img src={slide.image} alt={`slide-${idx}`} className="simple-img" />
                                </SwiperSlide>
                            ))}

                        </Swiper>

                        <div className="swiper-button-prev-custom nav-btn left">‹</div>
                        <div className="swiper-button-next-custom nav-btn right">›</div>
                    </div>

                    {/* <SlideCard index={activeIndex} /> */}

                </Container>
            </section>
        </>
    );
};

export default Features;
